/* eslint-disable no-lone-blocks */
/* eslint-disable no-case-declarations */
/* eslint-disable camelcase */
import { nanoid } from 'nanoid'
import { cloneDeep } from 'lodash'
import store from '../../store'
import {
  HIGH_CAPACITY_TRANSIT_FACILITY,
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  TRANSIT_STOP_AMENITIES,
  TRANSIT_STOP_AMENITIES_VALUES
} from '../constants/transit'
import {
  addMultipleSegments,
  addSegment,
  removeAllMatchingSegments,
  removeAllSimilarSegmentNames,
  updateFinalStreet
} from './multimodal.utils'
import {
  BUFFER_QUALITY_VALUES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE_VALUES
} from '../constants/pedestrian'
import { setPedestrianInputs } from '../slices/criteriaSelection/pedestrian'

export function setTransitStreetmixInput(field) {
  const { transit, street, modalTiers, pedestrian } = store.getState()
  const { transit_stop_amenities, high_capacity_transit_facility } = transit
  const { lighting, pedestrian_facility_type, buffer_quality } = pedestrian
  const { Transit: TTier } = modalTiers

  const { segments } = street

  switch (field) {
    case TRANSIT_STOP_AMENITIES:
      let segmentCopy = cloneDeep(segments)

      const driveLaneElevation = segments.find(
        (segment) => segment?.type === 'drive-lane'
      )?.elevation

      // Comment out SHELTER
      // if users selects shelter
      {
        /**
      if (
        // transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[0]) ||
        transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
      ) {
        // Remove all benches
        // segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk-bench')
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'transit-shelter')

        // Add shelters to first and last segments
        const leftShelter = {
          type: 'transit-shelter',
          variantString: 'left|street-level',
          variant: {
            orientation: 'left',
            'transit-shelter-elevation': 'street-level'
          },
          width: 9
        }
        const rightShelter = {
          type: 'transit-shelter',
          variantString: 'right|street-level',
          variant: {
            orientation: 'right',
            'transit-shelter-elevation': 'street-level'
          },
          width: 9
        }
        const firstLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type?.indexOf('lane') !== -1 &&
            segment?.type?.indexOf('parking-lane') === -1
        )

        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            firstLaneIndex - 2,
            { ...leftShelter, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            firstLaneIndex - 1,
            { ...leftShelter, id: nanoid() },
            segmentCopy
          )
        }

        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segmentCopy]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )?.id

        const lastLandeIndex = segmentCopy.findIndex(
          (segment) => segment?.id === lastLaneId
        )
        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            lastLandeIndex + 3,
            { ...rightShelter, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            lastLandeIndex + 2,
            { ...rightShelter, id: nanoid() },
            segmentCopy
          )
        }
      } else if (
        // if users selects sign or shelter or bench, add all three
        // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[0]) ||
        !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
      ) {
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'transit-shelter')
      }
      **/
      }

      // Comment out LIGHTING
      // if (transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[2])) {
      //   // if pedestrian lighting is already selected, leave those lamps as is , no need to add any lamps for transit
      //   if (
      //     // no pedestrian lamps
      //     lighting === LIGHTING_VALUES[2]
      //   ) {
      //     // First remove all lamps
      //     segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')
      //     const firstLaneIndex = segmentCopy.findIndex(
      //       (segment) =>
      //         segment?.type?.indexOf('lane') !== -1 &&
      //         segment?.type?.indexOf('parking-lane') === -1
      //     )

      //     const leftLamp = {
      //       type: 'sidewalk-lamp',
      //       variant: {
      //         'lamp-orientation': 'left',
      //         'lamp-type': 'modern'
      //       },
      //       variantString: 'left|modern',
      //       width: 2
      //     }
      //     const rightLamp = {
      //       type: 'sidewalk-lamp',
      //       variant: {
      //         'lamp-orientation': 'right',
      //         'lamp-type': 'modern'
      //       },
      //       variantString: 'right|modern',
      //       width: 2
      //     }
      //     const isSidewalkDetached =
      //       pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]

      //     let isBufferQuality = false
      //     if (
      //       buffer_quality === BUFFER_QUALITY_VALUES[0] ||
      //       buffer_quality === BUFFER_QUALITY_VALUES[1] ||
      //       buffer_quality === BUFFER_QUALITY_VALUES[2]
      //     ) {
      //       isBufferQuality = true
      //     }

      //     // if lanes dont exist, add them
      //     if (firstLaneIndex === -1) {
      //       segmentCopy = addSegment(
      //         0,
      //         {
      //           ...rightLamp,
      //           id: nanoid()
      //         },
      //         segmentCopy
      //       )
      //     } else {
      //       // Add lamp near first  lane, pedestrian lamp

      //       const index =
      //         isSidewalkDetached && isBufferQuality
      //           ? firstLaneIndex - 1 === -1
      //             ? 0
      //             : firstLaneIndex - 1
      //           : firstLaneIndex

      //       segmentCopy = addSegment(
      //         index,
      //         {
      //           ...rightLamp,
      //           id: nanoid()
      //         },
      //         segmentCopy
      //       )
      //       // Reverse segments to find last lane id
      //       const copyOfSegmentsToReverse = [...segmentCopy]

      //       const lastLaneId = copyOfSegmentsToReverse
      //         .reverse()
      //         .find(
      //           (segment) =>
      //             segment?.type?.indexOf('lane') !== -1 &&
      //             segment?.type?.indexOf('parking-lane') === -1
      //         )?.id

      //       const lastLandeIndex = segmentCopy.findIndex(
      //         (segment) => segment?.id === lastLaneId
      //       )
      //       const segmentIndex =
      //         isSidewalkDetached && isBufferQuality
      //           ? lastLandeIndex + 2
      //           : lastLandeIndex + 1
      //       // Add lamp near first  lane, pedestrian lamp

      //       segmentCopy = addSegment(
      //         segmentIndex,
      //         {
      //           ...leftLamp,
      //           id: nanoid()
      //         },
      //         segmentCopy
      //       )
      //     }
      //   }
      // } else if (
      //   !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[2]) &&
      //   TTier !== 0
      // ) {
      //   segmentCopy = removeAllLamps(segmentCopy)
      //   // No Lighting
      //   store.dispatch(
      //     setPedestrianInputs({
      //       field: LIGHTING,
      //       value: LIGHTING_VALUES[2]
      //     })
      //   )
      // } else if (
      //   TTier === 0 &&
      //   lighting !== LIGHTING_VALUES[0] &&
      //   lighting !== LIGHTING_VALUES[1]
      // ) {
      //   segmentCopy = removeAllLamps(segmentCopy)
      // }

      // Comment out BIKE PARKING
      {
        /**
      if (transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])) {
        segmentCopy = removeAllMatchingSegments(
          segmentCopy,
          'sidewalk-bike-rack'
        )

        // Add bike rack to first and last segments
        const leftBikeRack = {
          type: 'sidewalk-bike-rack',
          variantString: 'left|sidewalk-parallel',
          variant: {
            orientation: 'left',
            'bike-rack-elevation': 'sidewalk-parallel'
          },
          width: 5
        }
        const rightBikeRack = {
          type: 'sidewalk-bike-rack',
          variantString: 'right|sidewalk-parallel',
          variant: {
            orientation: 'right',
            'bike-rack-elevation': 'sidewalk-parallel'
          },
          width: 5
        }
        const firstLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type?.indexOf('lane') !== -1 &&
            segment?.type?.indexOf('parking-lane') === -1
        )

        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            firstLaneIndex - 2,
            { ...leftBikeRack, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            firstLaneIndex - 1,
            { ...leftBikeRack, id: nanoid() },
            segmentCopy
          )
        }
        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segmentCopy]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )?.id

        const lastLandeIndex = segmentCopy.findIndex(
          (segment) => segment?.id === lastLaneId
        )
        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            lastLandeIndex + 3,
            { ...rightBikeRack, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            lastLandeIndex + 2,
            { ...rightBikeRack, id: nanoid() },
            segmentCopy
          )
        }
      } else if (
        !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
      ) {
        segmentCopy = removeAllMatchingSegments(
          segmentCopy,
          'sidewalk-bike-rack'
        )
      }
 **/
      }

      // if (transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[5])) {
      //   // Remove all benches
      //   // segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk-bench')
      //   segmentCopy = removeAllMatchingSegments(segmentCopy, 'transit-shelter')

      //   // Add shelters to first and last segments
      //   const raisedShelter = {
      //     type: 'transit-shelter',
      //     elevation: driveLaneElevation + 1,
      //     width: 9
      //   }

      //   // Add shelter to left side
      //   segmentCopy = addSegment(
      //     0,
      //     {
      //       ...raisedShelter,
      //       variantString: 'left|street-level',
      //       id: nanoid()
      //     },
      //     segmentCopy
      //   )
      //   // Add shelter to right side
      //   segmentCopy = addSegment(
      //     segments.length + 1,
      //     {
      //       ...raisedShelter,
      //       variantString: 'right|street-level',
      //       id: nanoid()
      //     },
      //     segmentCopy
      //   )
      // } else if (
      //   !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[5])
      // ) {
      //   segmentCopy = removeAllRaisedShelters(segmentCopy, driveLaneElevation)
      // }

      // Comment out BENCH
      {
        /**
      if (
        transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
        // &&
        // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1]) &&
        // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[0]) &&
        // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[5])
      ) {
        // Remove all benches
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk-bench')

        // Add bike rack to first and last segments
        const leftBench = {
          type: 'sidewalk-bench',
          variantString: 'left',
          variant: { 'bench-orientation': 'left' },
          width: 4
        }
        const rightBench = {
          type: 'sidewalk-bench',
          variantString: 'right',
          variant: { 'bench-orientation': 'right' },
          width: 4
        }
        const firstLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type?.indexOf('lane') !== -1 &&
            segment?.type?.indexOf('parking-lane') === -1
        )

        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            firstLaneIndex - 2,
            { ...leftBench, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            firstLaneIndex - 1,
            { ...leftBench, id: nanoid() },
            segmentCopy
          )
        }
        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segmentCopy]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )?.id

        const lastLandeIndex = segmentCopy.findIndex(
          (segment) => segment?.id === lastLaneId
        )
        // if segments includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          segmentCopy = addSegment(
            lastLandeIndex + 3,
            { ...rightBench, id: nanoid() },
            segmentCopy
          )
        } else {
          segmentCopy = addSegment(
            lastLandeIndex + 2,
            { ...rightBench, id: nanoid() },
            segmentCopy
          )
        }
      } else if (
        !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
        // &&
        // !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
      ) {
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk-bench')
      }
      **/
      }

      // const adjacentStripIndex = []
      // segmentCopy = segmentCopy.map((segment, index) => {
      //   if (
      //     segment.variantString === 'planting-strip' &&
      //     segmentCopy[index + 1]?.variantString === 'planting-strip'
      //   ) {
      //     adjacentStripIndex.push(index + 1)
      //     return {
      //       ...segment,
      //       width: segment.width + segmentCopy[index + 1]?.width
      //     }
      //   } else {
      //     return segment
      //   }
      // })
      // segmentCopy = segmentCopy.filter(
      //   (segment, index) => !adjacentStripIndex.includes(index)
      // )

      // const totalSegmentWidth = segmentCopy.reduce(
      //   (totalWidth, segment) => totalWidth + segment.width,
      //   0
      // )

      // const diffInWidth = totalSegmentWidth - street.width
      // let longestPlantingStripWidth = 0
      // segmentCopy.forEach((segment) => {
      //   if (
      //     segment.variantString === 'planting-strip' &&
      //     segment.width > longestPlantingStripWidth
      //   ) {
      //     longestPlantingStripWidth = segment.width
      //   }
      // })
      // if (totalSegmentWidth > street.width) {
      //   // adjust width of that detached sidewalk
      //   segmentCopy = segmentCopy.map((segment, index) => {
      //     if (
      //       segment.variantString === 'planting-strip' &&
      //       segment.width === longestPlantingStripWidth
      //     ) {
      //       return {
      //         ...segment,
      //         width: segment.width - Math.round((diffInWidth / 2) * 1000) / 1000
      //       }
      //     } else {
      //       return segment
      //     }
      //   })
      // } else if (totalSegmentWidth < street.width) {
      //   if (
      //     segmentCopy.some(
      //       (segment) => segment?.variantString === 'planting-strip'
      //     ) === true
      //   ) {
      //     // if there are planting strips
      //     // if there is some space in the street, add it to the planting strip
      //     segmentCopy = segmentCopy.map((segment, index) => {
      //       if (
      //         segment.variantString === 'planting-strip' &&
      //         segment.width === longestPlantingStripWidth
      //       ) {
      //         return {
      //           ...segment,
      //           width:
      //             segment.width +
      //             Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000)
      //         }
      //       } else {
      //         return segment
      //       }
      //     })
      //   } else {
      //     // if there are no planting strips
      //     const plantingStrip = {
      //       type: 'divider',
      //       variantString: 'planting-strip',
      //       width: 4
      //     }
      //     segmentCopy = addSegment(
      //       0,
      //       {
      //         ...plantingStrip,
      //         width: Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000),
      //         id: nanoid()
      //       },
      //       segmentCopy
      //     )
      //     segmentCopy = addSegment(
      //       segmentCopy.length,
      //       {
      //         ...plantingStrip,
      //         width: Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000),
      //         id: nanoid()
      //       },
      //       segmentCopy
      //     )
      //   }
      // }

      updateFinalStreet(segmentCopy)
      break
    case HIGH_CAPACITY_TRANSIT_FACILITY:
      // Check is input is no high capacity transit facility
      if (
        high_capacity_transit_facility ===
        HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
      ) {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllTransitLanes(segmentCopy)

        segmentCopy = removeAllRapidTransitLanes(segmentCopy)

        updateFinalStreet(segmentCopy)
      } else {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllTransitLanes(segmentCopy)
        segmentCopy = removeAllRapidTransitLanes(segmentCopy)
        segmentCopy = removeAllSharedPavementLanes(segmentCopy)

        // Check if road is one way or two way
        const segmentDirection = segmentCopy.map((segment) =>
          segment.type === 'drive-lane' && segment?.variant?.direction
            ? segment?.variant?.direction
            : null
        )
        const isRoadTwoWay =
          segmentDirection?.includes('inbound') &&
          segmentDirection?.includes('outbound')
        const busTransitLane = {
          type: 'bus-lane',
          variantString: 'inbound|regular|typical',
          variant: {
            direction: 'inbound',
            'bus-asphalt': 'regular',
            'bus-type': 'typical'
          },
          width: 12
        }
        const busTransitLaneCopy = {
          type: 'bus-lane',
          variantString: 'inbound|regular|typical|copy',
          variant: {
            direction: 'inbound',
            'bus-asphalt': 'regular',
            'bus-type': 'typical'
          },
          width: 12
        }
        const firstLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type?.indexOf('drive-lane') !== -1 &&
            segment?.type?.indexOf('parking-lane') === -1
        )

        if (
          high_capacity_transit_facility ===
          HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[1]
        ) {
          // Add bus lane
          segmentCopy = addSegment(
            firstLaneIndex - 1 <= -1
              ? Math.floor(segmentCopy.length / 2)
              : firstLaneIndex,
            {
              ...busTransitLane,
              id: nanoid()
            },
            segmentCopy
          )

          if (isRoadTwoWay) {
            // Reverse segments to find last lane id
            const copyOfSegmentsToReverse = [...segmentCopy]

            const lastLaneId = copyOfSegmentsToReverse
              .reverse()
              .find(
                (segment) =>
                  segment?.type?.indexOf('drive-lane') !== -1 &&
                  segment?.type?.indexOf('parking-lane') === -1
              )?.id

            const lastLandeIndex = segmentCopy.findIndex(
              (segment) => segment?.id === lastLaneId
            )
            // Add bus lane
            segmentCopy = addSegment(
              lastLandeIndex + 1,
              {
                ...busTransitLane,
                variantString: 'outbound|regular|typical',
                variant: {
                  direction: 'outbound',
                  'bus-asphalt': 'regular',
                  'bus-type': 'typical'
                },
                id: nanoid()
              },
              segmentCopy
            )
          }
        } else if (
          high_capacity_transit_facility ===
          HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[2]
        ) {
          // Add bus lane
          segmentCopy = addSegment(
            firstLaneIndex - 1 <= -1
              ? Math.floor(segmentCopy.length / 2)
              : firstLaneIndex,
            {
              ...busTransitLaneCopy,
              id: nanoid()
            },
            segmentCopy
          )

          if (isRoadTwoWay) {
            // Reverse segments to find last lane id
            const copyOfSegmentsToReverse = [...segmentCopy]

            const lastLaneId = copyOfSegmentsToReverse
              .reverse()
              .find(
                (segment) =>
                  segment?.type?.indexOf('drive-lane') !== -1 &&
                  segment?.type?.indexOf('parking-lane') === -1
              )?.id

            const lastLandeIndex = segmentCopy.findIndex(
              (segment) => segment?.id === lastLaneId
            )
            // Add bus lane
            segmentCopy = addSegment(
              lastLandeIndex + 1,
              {
                ...busTransitLaneCopy,
                variantString: 'outbound|regular|typical|copy',
                variant: {
                  direction: 'outbound',
                  'bus-asphalt': 'regular',
                  'bus-type': 'typical'
                },
                id: nanoid()
              },
              segmentCopy
            )
          }
        } else if (
          high_capacity_transit_facility ===
          HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[0]
        ) {
          // Get center drive lane index
          const laneArr = segmentCopy.filter((segment) =>
            segment?.type?.includes('drive-lane')
          )

          const centerLaneId = laneArr[Math.floor(laneArr.length / 2)]?.id

          const centerLaneIndex = segmentCopy.findIndex(
            (segment) => segment?.id === centerLaneId
          )
          // Add transit bus lanes
          const toBeAddedSegments = [
            busTransitLane,
            {
              ...busTransitLane,
              variantString: 'outbound|regular|typical',
              variant: {
                direction: 'outbound',
                'bus-asphalt': 'regular',
                'bus-type': 'typical'
              },
              id: nanoid()
            }
          ]
          segmentCopy = addMultipleSegments(
            toBeAddedSegments,
            centerLaneIndex !== -1
              ? centerLaneIndex
              : Math.floor(segmentCopy.length / 2),
            segmentCopy
          )

          // Once the center transit lanes are added, make sure no of. lanes on left is equal to np. of lanes on the right
          // Check for Transit lanes
          const transitLaneArr = segmentCopy.filter(
            (segment) => segment?.type === 'bus-lane'
          )

          // Transit lane indexes
          const transitLaneIndexes = transitLaneArr.map((transitLane) =>
            segmentCopy.findIndex((segment) => segment?.id === transitLane?.id)
          )
          // Get the number of lanes to left and right of the transit lane
          const noOfLanesLeft = segmentCopy.filter(
            (lane, laneIndex) =>
              laneIndex < transitLaneIndexes[0] &&
              lane?.type?.includes('drive-lane')
          ).length

          const noOfLanesRight = segmentCopy.filter(
            (lane, laneIndex) =>
              laneIndex > transitLaneIndexes[1] &&
              lane?.type?.includes('drive-lane')
          ).length
          const driveLane = {
            type: 'drive-lane',
            width: 10,
            variantString: 'inbound|car',
            variant: {
              direction: 'inbound',
              'car-type': 'car'
            },
            elevation: 0
          }

          if (noOfLanesLeft < noOfLanesRight) {
            segmentCopy = addSegment(
              transitLaneIndexes[0] - 1,
              {
                ...driveLane,

                id: nanoid()
              },
              segmentCopy
            )
          } else if (noOfLanesLeft > noOfLanesRight) {
            segmentCopy = addSegment(
              transitLaneIndexes[1] + 1,
              {
                ...driveLane,

                id: nanoid()
              },
              segmentCopy
            )
          }
        }

        updateFinalStreet(segmentCopy)
      }
      break
    default:
  }
}

export function removeAllRaisedShelters(segmentCopy, driveLaneElevation) {
  // get all macthing segments indexes
  const segmentIndexArr = segmentCopy
    .map((segment, index) => {
      if (
        segment?.type === 'transit-shelter' &&
        segment?.elevation >= driveLaneElevation + 1
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !segmentIndexArr.includes(index)
  )
}
function removeAllSharedPavementLanes(segmentCopy) {
  // identify if shared lanes are bus or car lanes
  const segmentType = segmentCopy
    .map((segment, index) => {
      if (
        (segment?.type === 'drive-lane' ||
          segment?.type === 'bus-lane' ||
          segment?.type === 'brt-lane') &&
        (segment?.variantString?.includes('sharrow') ||
          segment?.variantString?.includes('shared'))
      ) {
        return segment?.type
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  // get all sahred bieklane indexes
  const sharedLanesIndexes = segmentCopy
    .map((segment, index) => {
      if (
        (segment?.type === 'drive-lane' ||
          segment?.type === 'bus-lane' ||
          segment?.type === 'brt-lane') &&
        (segment?.variantString?.includes('sharrow') ||
          segment?.variantString?.includes('shared'))
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)

  const driveLane = {
    type: 'drive-lane',
    width: 12,
    variantString: 'inbound|car',
    variant: {
      direction: 'inbound',
      'car-type': 'car'
    },
    elevation: 0
  }

  const busLane = {
    type: 'bus-lane',
    width: 12,
    variantString: 'inbound|regular|typical',
    variant: {
      direction: 'inbound',
      'bus-type': 'typical'
    }
  }
  segmentCopy = segmentCopy.filter(
    (segment, index) => !sharedLanesIndexes.includes(index)
  )

  // check if two way
  if (sharedLanesIndexes.length === 2) {
    segmentCopy = addSegment(
      sharedLanesIndexes[0],
      segmentType[0] === 'drive-lane'
        ? {
            ...driveLane,

            id: nanoid()
          }
        : {
            ...busLane,

            id: nanoid()
          },
      segmentCopy
    )
    segmentCopy = addSegment(
      sharedLanesIndexes[1],
      segmentType[1] === 'drive-lane'
        ? {
            ...driveLane,
            variantString: 'outbound|car',
            variant: {
              direction: 'outbound',
              'car-type': 'car'
            },
            id: nanoid()
          }
        : {
            ...busLane,
            variantString: 'outbound|regular|typical',
            variant: {
              direction: 'outbound',
              'bus-type': 'typical'
            },
            id: nanoid()
          },
      segmentCopy
    )
  } else {
    for (let i = 0; i < sharedLanesIndexes.length; i++) {
      segmentCopy = addSegment(
        sharedLanesIndexes[i],
        {
          ...driveLane,

          id: nanoid()
        },
        segmentCopy
      )
    }
  }

  return segmentCopy
}

function removeAllTransitLanes(segmentCopy) {
  // get all macthing segments indexes
  const segmentIndexArr = segmentCopy
    .map((segment, index) => {
      if (segment?.type === 'bus-lane') {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !segmentIndexArr.includes(index)
  )
}

function removeAllRapidTransitLanes(segmentCopy) {
  // get all macthing segments indexes
  const segmentIndexArr = segmentCopy
    .map((segment, index) => {
      if (segment?.type === 'brt-lane') {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !segmentIndexArr.includes(index)
  )
}

function removeAllLamps(segmentCopy) {
  // get all macthing segments indexes
  const segmentIndexArr = segmentCopy
    .map((segment, index) => {
      if (segment?.type === 'sidewalk-lamp') {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !segmentIndexArr.includes(index)
  )
}
